// SAP Basic Authentication credetials format
export const getBase64Credentials = (user, password) => window.btoa(`${user}:${password}`);

